"use client";

import { useState } from "react";
import { usePortalTranslations } from "../i18n/client";
import type { PortalIdentity } from "../lib/clientPortalApi";
import { PortalProfileMenu } from "./PortalProfileMenu";
import styles from "./PortalSurface.module.css";

export function PortalDirectoryAccount({ identity, loginHref, unavailable }: {
  identity: PortalIdentity | null;
  loginHref: string;
  unavailable: boolean;
}) {
  const t = usePortalTranslations();
  const [loggingOut, setLoggingOut] = useState(false);
  const [logoutFailed, setLogoutFailed] = useState(false);

  async function logout() {
    setLoggingOut(true);
    setLogoutFailed(false);
    try {
      const response = await fetch("/api/client-portals/_directory/logout", { method: "POST", credentials: "same-origin" });
      if (!response.ok && response.status !== 401) throw new Error("Logout failed.");
      window.location.assign("/");
    } catch {
      setLogoutFailed(true);
      setLoggingOut(false);
    }
  }

  if (unavailable) return <button type="button" className={styles.accountButton} onClick={() => window.location.reload()}>{t("profile.reloadAccount")}</button>;
  if (!identity) return <a className={styles.loginLink} href={loginHref}>{t("profile.login")} <span aria-hidden="true">↗</span></a>;

  return <div className={styles.account}>
    <PortalProfileMenu identity={identity} loggingOut={loggingOut} onLogout={logout} onTopbar />
    {logoutFailed ? <div className={styles.accountMenu} role="alert">{t("profile.logoutFailed")}</div> : null}
  </div>;
}
